var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"loading"},[_c('div',{staticClass:"loader "},[_c('div',{staticClass:"loader__filmstrip"})])])])}]

export { render, staticRenderFns }